

















import Vue from 'vue'
import agora from '@/services/Agora'
import Loader from '@/components/global/loader.vue'

export default Vue.extend({
  components: { Loader },
  props: {
    guest_count: Number,
    guest: Object,
    index: Number,
  },
  name: 'AgoraView',
  beforeDestroy() {
    agora.stop(this.guest.id)
  },
})
